import React from 'react';

const SendIcon = ({ width = 24, height = 24, fill = '#000000', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 2H3v20h13v-7h1v8H2V1h15v9h-1zm3.425 6.632l-.707.707L21.378 12H9v1h12.309l-2.649 2.648.707.707 3.89-3.89z"
        fill={fill}
      />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
  );
};

export default SendIcon;
